import React, { createContext, useState } from "react";
import { LANGUAGES } from "../../utils/constants";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(LANGUAGES.en);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
